import { ref } from 'vue'
import { defineStore } from 'pinia'
import { setLocale } from '../includes/dayjs'

export const useStore = defineStore("index", () => {
	// Properties
	const authenticated = ref()
	const settings = ref({
		languagesSupported: [],
		masterServerUrl: "",
		fbAppId: null,
		linkedinKey: null,
		googleId: null,
		locationIqToken: null,
		appleClientId: null,
		defaultLanguage: null,
		userFriendsEnabled: null,
		owner_id: null,
		ui: {
			footerForceBottomOnDesktop: null,
			layoutShowSignupButton: null,
			mainMenuOrderMobile: null,
			mainMenuOrderDesktop: null,
			showUnusedRewardsBadge: null,
			partnerBlockShow: null,
			soundsEnabled: null
		},
		enabledCountries: null,
		notification: null,
		registration_type: null,
		soundsMuted: null,
		turnstileKey: null
	})
	const offline = ref(false)
	const loaderContent = ref("default" as string | false)
	const isMobile = ref()
	const colorTheme = ref('light')
	const currentLanguage = ref()
	const translations = ref()
	const owner = ref()
	const referralId = ref()
	const facebookLoaded = ref(false)
	const facebookUserId = ref("me")
	const applyReferralCodeEnabled = ref()
	const applyPromoCodeEnabled = ref()
	const rewards = ref(null)
	const menuItems = ref()
	const genericModalOpened = ref(false)
	const smsInitiator = ref()
	const signInData = ref({
		phoneNumber: "",
		name: "",
		surname: "",
		turnstileToken: "",
	})

	const isPushSetUp = ref(false)
	const isPushDenied = ref(false)
	const isPushNotDenied = ref(false)
	const isPushGranted = ref(false)

	/**
	 * Set current language for the user
	 * @param value 
	 */
	function setCurrentLanguage(value: string){
		currentLanguage.value = value

		// Set dayjs locale on language change
		setLocale(value)
	}

	return {
		authenticated,
		settings,
		offline,
		loaderContent,
		isMobile,
		colorTheme,
		currentLanguage,
		translations,
		owner,
		referralId,
		facebookLoaded,
		facebookUserId,
		applyReferralCodeEnabled,
		applyPromoCodeEnabled,
		rewards,
		menuItems,
		genericModalOpened,
		smsInitiator,
		signInData,
		isPushSetUp,
		isPushDenied,
		isPushGranted,
		isPushNotDenied,
		setCurrentLanguage,
	}
})